import script from "./MealPresetCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MealPresetCard.vue?vue&type=script&setup=true&lang=js"

import "./MealPresetCard.vue?vue&type=style&index=0&id=8f3d7c98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f3d7c98"]])

export default __exports__